import type {
    IsoAndUnixTimestamp} from "@@/shared/date-time/iso-and-unix";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import type { Price} from "@@/shared/prices/price";
import { priceZodSchema } from "@@/shared/prices/price";
import type { Except } from "type-fest";
import { z } from "zod";
import type { ResourcePrice } from "./resource-price";
import type {
    ResourcePriceId} from "./resource-price-id";
import {
    resourcePriceIdFactory,
    resourcePriceIdZodSchema,
} from "./resource-price-id";

type ResourcePriceFixed = {
    readonly _id: ResourcePriceId;
    readonly _type: "RESOURCE_PRICE_FIXED";
    readonly _createdAt: IsoAndUnixTimestamp;
    readonly price: Price;
};

type resourcePriceFixedFactoryParams = Except<
    ResourcePriceFixed,
    "_id" | "_type" | "_createdAt"
> & { _id?: ResourcePriceId };

const resourcePriceFixedFactory = (
    params: resourcePriceFixedFactoryParams,
): ResourcePriceFixed => {
    return {
        ...params,
        _id: params._id || resourcePriceIdFactory(),
        _type: "RESOURCE_PRICE_FIXED",
        _createdAt: nowIsoAndUnix(),
    };
};

const isResourcePriceFixed = (
    item: ResourcePrice,
): item is ResourcePriceFixed => {
    return item._type === "RESOURCE_PRICE_FIXED";
};

const resourcePriceFixedZodSchema: z.ZodSchema<ResourcePriceFixed> = z.object({
    _id: resourcePriceIdZodSchema,
    _type: z.literal("RESOURCE_PRICE_FIXED"),
    _createdAt: isoAndUnixZodSchema,
    price: priceZodSchema,
});

export {
    isResourcePriceFixed,
    resourcePriceFixedFactory,
    resourcePriceFixedZodSchema,
};
export type { ResourcePriceFixed };
